const sortButton = document.getElementById('sortButton');
const sortOptions = document.getElementById('sortOptions');
const sortClose = document.getElementById('sortClose');  // The SVG element for closing
let facetForm = document.querySelector('facet-filters-form form');  // Main form handling facets

// Function to handle sorting
function handleSort(selectedValue, selectedText, option) {
  // Dynamically re-select the original select element each time
  const selectElement = document.getElementById('SortBy');

  // Update the custom button text to show the selected option
  sortButton.innerHTML = `Sort: ${selectedText}`;

  // Set the value of the original select element
  if (selectElement) {
    selectElement.value = selectedValue;

    // Trigger the 'input' event on the form to let the FacetFiltersForm JavaScript handle the sorting
    const inputEvent = new Event('input', { bubbles: true });
    facetForm.dispatchEvent(inputEvent);  // This triggers the form submission handling logic
  }

  // Update aria-selected and focus management
  document.querySelectorAll('#sortOptions li').forEach(li => {
    li.setAttribute('aria-selected', 'false');
    li.setAttribute('tabindex', '-1');
  });
  option.setAttribute('aria-selected', 'true');
  option.setAttribute('tabindex', '0');

  // Hide the dropdown after selection
  sortOptions.style.display = 'none';
  sortButton.setAttribute('aria-expanded', 'false');
}

// Event delegation: handle clicks on any list item within the sortOptions container
sortOptions.addEventListener('click', function(event) {
  const option = event.target.closest('li');
  if (option && sortOptions.contains(option)) {
    const selectedValue = option.getAttribute('data-value');
    const selectedText = option.textContent.trim();
    handleSort(selectedValue, selectedText, option);
  }
});

// Toggle dropdown visibility on button click and update aria-expanded
sortButton.addEventListener('click', function() {
  const expanded = sortButton.getAttribute('aria-expanded') === 'true';
  sortButton.setAttribute('aria-expanded', !expanded);
  sortOptions.style.display = expanded ? 'none' : 'block';
});

// Close dropdown when clicking the SVG close button
sortClose.addEventListener('click', function() {
  sortOptions.style.display = 'none';
  sortButton.setAttribute('aria-expanded', 'false');
});

// Keyboard accessibility: allow arrow keys and Enter to navigate the list
sortOptions.addEventListener('keydown', function(e) {
  const focusedElement = document.activeElement;
  if (e.key === 'ArrowDown') {
    const next = focusedElement.nextElementSibling || sortOptions.firstElementChild;
    next.focus();
  } else if (e.key === 'ArrowUp') {
    const prev = focusedElement.previousElementSibling || sortOptions.lastElementChild;
    prev.focus();
  } else if (e.key === 'Enter') {
    focusedElement.click();
  }
});

// Close dropdown if clicked outside
document.addEventListener('click', function(event) {
  if (!sortButton.contains(event.target) && !sortOptions.contains(event.target) && event.target !== sortClose) {
    sortOptions.style.display = 'none';
    sortButton.setAttribute('aria-expanded', 'false');
  }
});
